<div
  class="flex flex-col h-full"
  [ngStyle]="{
    'width': isCollapsed ? '3rem' : '18rem',
    'transition': 'all 0.3s ease-in-out',
  }"
  [ngClass]="{'items-center': isCollapsed}"
  *transloco="let t; prefix: 'project.sideMenu'"
  data-testid="project-side-menu-container"
>
  <div class="flex items-center justify-between">
    @if (!isCollapsed) {
      <span
        class="text-sm font-semibold truncate mr-2"
        [attr.data-testid]="'project-side-menu-project-name'"
      >
        {{ projectDataService.getProject()()?.name }}
      </span>
    }
    <p-button
      severity="secondary"
      icon="pi pi-bars"
      class="shrink-0"
      (onClick)="toggleCollapse()"
      data-testid="project-side-menu-collapse-expand-button"
    ></p-button>
  </div>

  <p-divider></p-divider>

  @if (!isCollapsed) {
    <p-button
      [label]="t('backToOverview')"
      icon="pi pi-arrow-left"
      styleClass="p-button-secondary w-full text-sm! tracking-wider uppercase py-3! truncate"
      (onClick)="backToProject()"
      data-testid="project-side-menu-back-button"
    ></p-button>
  } @else {
    <p-button
      icon="pi pi-arrow-left"
      styleClass="p-button-secondary p-2!"
      (onClick)="backToProject()"
      data-testid="project-side-menu-back-icon-button"
    ></p-button>
  }

  <div class="card mt-4 text-sm mb-0!" data-testid="project-side-menu-progress-card">
    <div class="flex items-center" [ngClass]="isCollapsed ? 'justify-center' : 'justify-between'">
      @if (!isCollapsed) {
        <span class="text-gray-400 truncate" data-testid="project-side-menu-progress-label">
          {{ t('stepsCompleted') }}</span
        >
      }
      <span data-testid="project-side-menu-progress-value"
        >{{ stepState.completedChaptersCount() }}/{{ stepState.totalChapters() }}</span
      >
    </div>
    @if (!isCollapsed) {
      <p-progressBar
        [value]="stepState.progressPercent()"
        [showValue]="false"
        [class]="'mt-2 ' + (stepState.progressPercent() === 100 ? 'completed-progress' : '')"
        [style]="{'height': '4px'}"
        data-testid="project-side-menu-progress-bar"
      ></p-progressBar>
    }
  </div>
  <div *appProjectRoleAccess="projectManagerAndTenantAdminAccessConfig()">
    <p-divider></p-divider>
    @if (!isCollapsed) {
      <div class="pl-3" data-testid="project-side-menu-user-management">
        <div class="py-1 text-gray-400 truncate">{{ t('collaboration') }}</div>
        <p-button
          [label]="t('userManagement')"
          icon="pi pi-users"
          styleClass="p-button-secondary w-full text-sm! truncate"
          data-testid="project-side-menu-user-management-button"
          [class.p-button-highlighted]="isUserManagement()"
          (onClick)="navigateToUserManagement()"
        ></p-button>
        @if (isRfiInvitationsStepCompleted()) {
          <p-button
            [label]="t('providerCommunication')"
            icon="pi pi-comments"
            styleClass="mt-4 p-button-secondary w-full text-sm! truncate"
            data-testid="project-side-menu-providerCommunication-button"
            [class.p-button-highlighted]="isUserManagement()"
            (onClick)="navigateToProviderCommunication()"
          ></p-button>
        }
      </div>
    } @else {
      <div class="flex flex-col gap-4 items-center py-2">
        <p-button
          icon="pi pi-users"
          styleClass="p-button-secondary p-2!"
          (onClick)="navigateToUserManagement()"
          data-testid="project-side-menu-user-management-icon-button"
        ></p-button>
        @if (isRfiInvitationsStepCompleted()) {
          <p-button
            icon="pi pi-comments"
            styleClass="p-button-secondary p-2!"
            (onClick)="navigateToProviderCommunication()"
            data-testid="project-side-menu-providerCommunication-icon-button"
          ></p-button>
        }
      </div>
    }
    <p-divider></p-divider>
  </div>

  @if (!isCollapsed) {
    <div class="pl-3 py-1 text-gray-400 truncate" data-testid="project-side-menu-chapters-label">
      {{ t('chapters') }}
    </div>
  }

  <p-panelMenu
    [model]="menuItems"
    [multiple]="true"
    styleClass="w-full"
    [ngClass]="{'menu-collapsed': isCollapsed}"
    data-testid="project-side-menu-chapters"
  >
    <ng-template #item let-item>
      @if (item.items) {
        <div
          class="flex items-center justify-between mb-2 w-full"
          [attr.data-testid]="'project-side-menu-chapter-' + item.id"
        >
          <button
            type="button"
            pRipple
            class="flex items-center gap-2 flex-1 pl-3 py-3 text-left bg-transparent border-0 focus:outline-hidden overflow-hidden"
            [ngClass]="{
              'cursor-pointer': item.accessible,
              'cursor-not-allowed opacity-50': !item.accessible,
            }"
            [pTooltip]="!item.accessible ? ('project.sideMenu.noAccess' | transloco) : ''"
            [tooltipDisabled]="item.accessible"
            tooltipPosition="top"
            (click)="item.accessible ? showStepDescription($event, item.directusId) : null"
            [attr.data-testid]="'project-side-menu-chapter-description-button-' + item.id"
          >
            <i
              [class]="item.icon + ' group-hover:text-inherit shrink-0'"
              [ngClass]="{'text-gray-500': !item.accessible}"
            ></i>
            @if (!isCollapsed) {
              <span
                class="truncate max-w-full"
                [ngClass]="{'text-gray-500': !item.accessible}"
                [attr.data-testid]="'project-side-menu-chapter-heading-' + item.id"
                >{{ item.label }}</span
              >
              <p-badge
                [value]="item.badge"
                [severity]="item.badgeSeverity"
                class="text-white! ml-auto mr-2 shrink-0"
                [attr.data-testid]="'project-side-menu-chapter-badge-' + item.id"
              ></p-badge>
            }
          </button>

          @if (!isCollapsed) {
            <div class="pr-3 shrink-0">
              <div
                class="flex items-center justify-center w-6 h-6 rounded-sm transition-transform duration-200"
                [ngClass]="{
                  'bg-gray-600 hover:bg-gray-500 cursor-pointer': item.accessible,
                  'bg-gray-700 cursor-not-allowed opacity-50': !item.accessible,
                }"
                [attr.data-testid]="'project-side-menu-chapter-expansion-button-' + item.id"
              >
                <i
                  class="pi pi-chevron-down text-sm transition-transform duration-200"
                  [ngClass]="{
                    'text-gray-300': item.accessible,
                    'text-gray-500': !item.accessible,
                    'transform rotate-180': item.expanded,
                  }"
                ></i>
              </div>
            </div>
          }
        </div>
      } @else {
        <span
          pRipple
          class="flex items-center px-3 py-2 w-full text-sm overflow-hidden rounded-md"
          [ngClass]="{
            'justify-center': isCollapsed,
            'cursor-pointer text-gray-300': item.accessible,
            'cursor-not-allowed text-gray-500 opacity-50': !item.accessible,
            'bg-rose-950 text-white hover:bg-stone-800':
              item.chapterStep === activeStepChapterStepId(),
          }"
          [pTooltip]="!item.accessible ? ('project.sideMenu.noAccess' | transloco) : ''"
          [tooltipDisabled]="item.accessible"
          tooltipPosition="top"
          [attr.data-testid]="'project-side-menu-chapter-step-' + item.chapterStep"
        >
          @if (!isCollapsed) {
            <span class="truncate grow">
              {{ item.label }}
            </span>
          }
          <i
            class="pi shrink-0"
            [ngClass]="{
              'ml-auto': !isCollapsed,
              'pi-lock text-green-500! opacity-100!': item.locked,
              'pi-circle':
                !item.locked && (item.status === 'not-started' || item.status === 'in-progress'),
              'text-gray-400': !item.locked && item.status === 'not-started',
              'text-blue-500': !item.locked && item.status === 'in-progress',
              'pi-check-circle text-green-500': !item.locked && item.status === 'completed',
            }"
            [attr.data-testid]="'project-side-menu-step-status-' + item.chapterStep"
          ></i>
        </span>
      }
    </ng-template>
  </p-panelMenu>
</div>
